import argentinaImg from '../assets/options/argentina.png';
import capeVerdeImg from '../assets/options/cape-verde.png';
import messiImg from '../assets/options/messi.png';
import ronaldoImg from '../assets/options/ronaldo.png';
import tacosImg from '../assets/options/tacos.png';
import pizzaImg from '../assets/options/pizza.png';
import coffeeImg from '../assets/options/coffee.png';
import teaImg from '../assets/options/tea.png';
import salsaImg from '../assets/options/salsa.png';
import reggaetonImg from '../assets/options/reggaeton.png';
import summerImg from '../assets/options/summer.png';
import winterImg from '../assets/options/winter.png';

export const mockMaps = [
  {
    id: "m1",
    supabaseId: "a0000001-0001-4001-8001-000000000001",
    title: "Argentina vs Cape Verde",
    region: "Americas",
    defaultMemeText: "WHO'S WINNING LATIN AMERICA?",
    optionA: { name: "Argentina", color: "#39FF14", image: argentinaImg },
    optionB: { name: "Cape Verde", color: "#FF007F", image: capeVerdeImg },
    votesA: 6200,
    votesB: 3800,
    countryVotes: { "AR": "A", "BR": "B", "CL": "B", "PE": "A", "CO": "A" }
  },
  {
    id: "m2",
    supabaseId: "a0000002-0002-4002-8002-000000000002",
    title: "Messi vs Ronaldo",
    region: "World",
    defaultMemeText: "THE DEBATE NEVER ENDS",
    optionA: { name: "Messi", color: "#00FFFF", image: messiImg },
    optionB: { name: "Ronaldo", color: "#FF5F1F", image: ronaldoImg },
    votesA: 8500,
    votesB: 4200,
    countryVotes: { "AR": "A", "BR": "A", "CL": "B", "PE": "A", "CO": "B" }
  },
  {
    id: "m3",
    supabaseId: "a0000003-0003-4003-8003-000000000003",
    title: "Tacos vs Pizza",
    region: "Latin America",
    defaultMemeText: "THE ULTIMATE FOOD BATTLE",
    optionA: { name: "Tacos", color: "#FACC15", image: tacosImg },
    optionB: { name: "Pizza", color: "#EF4444", image: pizzaImg },
    votesA: 4500,
    votesB: 5100,
    countryVotes: { "AR": "B", "BR": "B", "CL": "B", "PE": "A", "CO": "A" }
  },
  {
    id: "m4",
    supabaseId: "a0000004-0004-4004-8004-000000000004",
    title: "Coffee vs Tea",
    region: "Americas",
    defaultMemeText: "MORNING RITUALS BY NATION",
    optionA: { name: "Coffee", color: "#92400e", image: coffeeImg },
    optionB: { name: "Tea", color: "#16a34a", image: teaImg },
    votesA: 3200,
    votesB: 2800,
    countryVotes: { "AR": "A", "BR": "A", "CL": "A", "PE": "B", "CO": "B" }
  },
  {
    id: "m5",
    supabaseId: "a0000005-0005-4005-8005-000000000005",
    title: "Salsa vs Reggaeton",
    region: "Latin America",
    defaultMemeText: "LATIN VIBES ONLY",
    optionA: { name: "Salsa", color: "#DC2626", image: salsaImg },
    optionB: { name: "Reggaeton", color: "#7C3AED", image: reggaetonImg },
    votesA: 1500,
    votesB: 6800,
    countryVotes: { "AR": "B", "BR": "B", "CL": "B", "PE": "B", "CO": "A" }
  },
  {
    id: "m6",
    supabaseId: "a0000006-0006-4006-8006-000000000006",
    title: "Summer vs Winter",
    region: "World",
    defaultMemeText: "GLOBAL TEMPERATURE BATTLE",
    optionA: { name: "Summer", color: "#FB923C", image: summerImg },
    optionB: { name: "Winter", color: "#60A5FA", image: winterImg },
    votesA: 9200,
    votesB: 8800,
    countryVotes: { "AR": "B", "BR": "A", "CL": "B", "PE": "A", "CO": "A" }
  }
];
